import { render, staticRenderFns } from "./TitleWithPenSwitcherMath.vue?vue&type=template&id=2aed592e&scoped=true&lang=pug&"
import script from "./TitleWithPenSwitcherMath.vue?vue&type=script&lang=ts&"
export * from "./TitleWithPenSwitcherMath.vue?vue&type=script&lang=ts&"
import style0 from "./TitleWithPenSwitcherMath.vue?vue&type=style&index=0&id=2aed592e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed592e",
  null
  
)

export default component.exports